import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LuUser, LuRuler, LuBell, LuUsers, LuTicket } from "react-icons/lu";

const SettingNav = () => {
  const location = useLocation();

  const menuItems = [
    { label: 'Account', icon: <LuUser />, path: '/profile' },
    { label: 'Measurement', icon: <LuRuler />, path: '/measurement' },
    { label: 'Notifications', icon: <LuBell />, path: '/notification' },
    { label: 'Teams', icon: <LuUsers />, path: '/team' },
    { label: 'Tickets', icon: <LuTicket />, path: '/support-ticket' },
  ];

  return (
    <div className="settings-header-container ">
      {/* Title Section */}
     

      <div className='page-title-section mb-3'>
                                <h1>Settings</h1>
                                <p className='page-subtitle' >Manage account, notifications, and team settings</p>
                            </div>


      {/* Navigation Tabs */}
      <div className="settings-nav-wrapper">
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`settings-tab-link ${isActive ? 'active' : ''}`}
            >
              <span className="tab-icon">{item.icon}</span>
              <span className="tab-label">{item.label}</span>
            </Link>
          );
        })}
      </div>

      <style>{`
        .settings-header-container {
          padding: 6px 0 0 0;
          background: transparent; 
        }

        .settings-title-group {
          margin-bottom: 14px;
          padding-left: 4px;
        }

        .settings-main-title {
          font-size: 19px;
          font-weight: 700;
          color: #1B2559;
          margin: 0 0 4px 0;
        }

        .settings-subtitle {
          font-size: 13px;
          color: #64748b;
          margin: 0;
        }

        .settings-nav-wrapper {
          display: flex;
          align-items: center;
          gap: 8px;
          border-bottom: 1px solid #E9EDF7;
          padding-bottom: 10px;
          overflow-x: auto;
          scrollbar-width: none;
        }

        .settings-nav-wrapper::-webkit-scrollbar {
          display: none;
        }

        .settings-tab-link {
          text-decoration: none;
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 6px 12px;
          border-radius: 10px;
          color: #64748b;
          font-size: 13px;
          font-weight: 600;
          transition: all 0.2s ease;
          white-space: nowrap;
        }

        .settings-tab-link:hover {
          color: #4318FF;
          background: #F4F7FE;
        }

        .tab-icon {
          display: flex;
          align-items: center;
          font-size: 18px;
        }

        /* Active State - Matches the Blue/Purple gradient in your image */
        .settings-tab-link.active {
          background: linear-gradient(135deg, #4318FF 0%, #3949AB 100%);
          color: #ffffff;
          box-shadow: 0px 4px 12px rgba(67, 24, 255, 0.25);
        }

        .settings-tab-link.active .tab-icon {
          color: #ffffff;
        }

        @media (max-width: 600px) {
          .settings-tab-link {
            padding: 6px 10px;
            font-size: 12px;
          }
          .tab-label {
            display: none; /* Show only icons on very small screens if desired */
          }
          .settings-tab-link.active .tab-label {
            display: inline; /* Keep label for active tab */
          }
        }
      `}</style>
    </div>
  );
};

export default SettingNav;